import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";

import OnboardingPageLayout from "../../../layouts/OnboardingPageLayout";
import TofuLayout from "@layout/TofuLayout";
import TofuLayoutWide from "@layout/TofuLayoutWide";
import ProtectRouteByFormStatus from "@routes/ProtectRouteByFormStatus";
import ProtectRouteAfterWaitingRoom from "@routes/ProtectRouteAfterWaitingRoom";
import ProtectRouteAuthenticated from "@routes/ProtectRouteAuthenticated";
import { Cotizador } from "@pages/producto/credito_simple/tofu_v2/Cotizador";
import { CrearCuenta } from "@pages/producto/credito_simple/tofu_v2/CrearCuenta";
import { RegistroDatosPersonalesPorEmpresa } from "@pages/producto/credito_simple/tofu_v2/RegistroDatosPersonalesPorEmpresa";
import { ValidacionTelefono } from "@pages/producto/credito_simple/tofu_v2/ValidacionTelefono";
import { PerfilIngresosMercader } from "@pages/producto/mercader/PerfilIngresosMercader";
import { InformacionEmpresa } from "@pages/producto/credito_simple/tofu_v2/InformacionEmpresa";
import { DecisionIngreso } from "@pages/producto/credito_simple/tofu_v2/DecisionIngreso";
import { ConexionSAT } from "@pages/producto/credito_simple/tofu_v2/ConexionSAT";
import { CargaDocumentos } from "@pages/producto/credito_simple/tofu_v2/CargaDocumentos";
import { NipBuro } from "@pages/producto/credito_simple/tofu_v2/NipBuro";
import { UsoCredito } from "@pages/producto/credito_simple/tofu_v2/UsoCredito";
import { PresenciaDigital } from "@pages/producto/credito_simple/tofu_v2/PresenciaDigital";
import { ConexionCuentas } from "@pages/producto/credito_simple/tofu_v2/ConexionCuentas";
import { UsoLinea } from "@pages/producto/credito_simple/tofu_v2/UsoLinea";
import { DatosAccionista } from "@pages/producto/credito_simple/tofu_v2/DatosAccionista";
import { DatosRepresentanteLegal } from "@pages/producto/credito_simple/tofu_v2/DatosRepresentanteLegal";
import { DomicilioAccionista } from "@pages/producto/credito_simple/tofu_v2/DomicilioAccionista";
import { DomicilioRepresentanteLegal } from "@pages/producto/credito_simple/tofu_v2/DomicilioRepresentanteLegal";
import { ConsultaBuroPm } from "@pages/producto/credito_simple/tofu_v2/ConsultaBuroPm";
import { DomicilioFiscal } from "@pages/producto/credito_simple/tofu_v2/DomicilioFiscal";
import { ConsultaBuro } from "@pages/producto/credito_simple/tofu_v2/ConsultaBuro";
import { AccionistaConfirmacion } from "@pages/producto/credito_simple/tofu_v2/AccionistaConfirmacion";
import { WaitingRoomPorEmpresa } from "@pages/producto/credito_simple/tofu_v2/WaitingRoomPorEmpresa";
import { OfertaPorEmpresa } from "@pages/producto/credito_simple/tofu_v2/OfertaPorEmpresa";
import { CreditoRechazado } from "@pages/producto/credito_simple/tofu_v2/CreditoRechazado";
import { SolicitudEnRevision } from "@pages/producto/credito_simple/tofu_v2/SolicitudEnRevision";
// import { Resultado } from "@pages/producto/credito_simple/tofu_v2/Resultado";
import { ListaRevision } from "@pages/producto/credito_simple/expediente_v2/ListaRevision";
import { ExpDictamen } from "@pages/producto/credito_simple/expediente_v2/ExpDictamen";
import { ExpInformacionSolicitud } from "@pages/producto/credito_simple/expediente_v2/ExpInformacionSolicitud";
import { ExpInformacionBancaria } from "@pages/producto/credito_simple/expediente_v2/ExpInformacionBancaria";
import { ExpEmpresa } from "@pages/producto/credito_simple/expediente_v2/ExpEmpresa";
import { ExpReferencias } from "@pages/producto/credito_simple/expediente_v2/ExpReferencias";
import { ExpPersonas } from "@pages/producto/credito_simple/expediente_v2/ExpPersonas";
import { ExpValId } from "@pages/producto/credito_simple/expediente_v2/ExpValId";
import { ExpReview } from "@pages/producto/credito_simple/expediente_v2/ExpReview";
import { InformacionMultiGarantias } from "@pages/producto/credito_simple/tofu_v2/InformacionMultiGarantias";
import { Ofertas } from "@pages/producto/credito_simple/tofu_v2/Ofertas";
import { OfertaSeleccionada } from "@pages/producto/credito_simple/tofu_v2/OfertaSeleccionada";
import { ExpedientePFAE } from "@pages/producto/credito_simple/expediente_v2/ExpedientePFAE";
import { ExpedienteCompletado } from "@pages/producto/credito_simple/expediente_v2/ExpedienteCompletado";

// TEMP: entra directo en "crear_cuenta" para testear su diseño. Cambiar a "cotizador" para volver al flujo normal.
const EMPRESAS_INITIAL_SLUG = "crear_cuenta";

const OnboardingRouter = () => {
  const appData = useSelector((state: RootState) => state.app);

  return (
    <Routes>
      <Route path="/" element={<OnboardingPageLayout />}>
        {/* Desde la sala de espera (CSCOF) ya no se puede volver a las pantallas anteriores. */}
        <Route element={<ProtectRouteAfterWaitingRoom />}>
          <Route index element={<Navigate to={appData.process_page} />} />

          <Route path="" element={<TofuLayout size="md" />}>
            <Route index element={<Navigate to={EMPRESAS_INITIAL_SLUG} replace />} />
            <Route path="cotizador" element={<Cotizador />} />
            <Route path="crear_cuenta" element={<CrearCuenta />} />
            {/* Crea la cuenta e inicia la sesión al enviarse: antes de eso no hay sesión. */}
            <Route path="registro_datos_personales" element={<RegistroDatosPersonalesPorEmpresa />} />

            {/* Todo lo demás del tofu requiere sesión. */}
            <Route element={<ProtectRouteAuthenticated />}>
              <Route path="validacion_telefono" element={<ValidacionTelefono />} />
              <Route path="informacion_empresa" element={<InformacionEmpresa />} />
              <Route path="consulta_ciec" element={<ConexionSAT />} />
              <Route path="uso_de_credito" element={<UsoCredito />} />
              <Route path="presencia_digital" element={<PresenciaDigital />} />
              <Route path="uso_de_linea" element={<UsoLinea />} />
              <Route path="datos_accionista" element={<DatosAccionista />} />
              {/* PM (Mercader): registro del representante legal (status CSDRL). */}
              <Route path="datos_representante_legal" element={<DatosRepresentanteLegal />} />
              <Route path="domicilio_accionista" element={<DomicilioAccionista />} />
              {/* PM (Mercader): domicilio del representante legal. */}
              <Route path="domicilio_representante_legal" element={<DomicilioRepresentanteLegal />} />
              {/* PM (Mercader): NIP de buró de la empresa (status CDCBE). */}
              <Route path="consulta_buro_pm" element={<ConsultaBuroPm />} />
              <Route path="consulta_buro" element={<ConsultaBuro />} />
              <Route path="informacion_multigarantias" element={<InformacionMultiGarantias />} />
              {/* Sala de espera por empresa (`waitingRoomPorEmpresa`); la genérica si no tiene propia. */}
              <Route path="waiting_room" element={<WaitingRoomPorEmpresa />} />

              {/* Rechazo de la solicitud (CSREC / CSRER), igual para cualquier empresa y producto. */}
              <Route path="credito_rechazado" element={<CreditoRechazado />} />
              {/* En revisión del equipo de crédito (CREVC): se llega por el status, no por la secuencia. */}
              <Route path="waiting_room_revision" element={<SolicitudEnRevision />} />
              <Route path="oferta_aceptada" element={<OfertaSeleccionada />} />
              <Route path="decision_ingreso" element={<DecisionIngreso />} />
              <Route path="carga_documentos" element={<CargaDocumentos />} />
              {/* Sin CIEC, llega desde `DecisionIngreso`: PFAE y PM en la misma pantalla (título y guardado por régimen). */}
              <Route path="domicilio_fiscal" element={<DomicilioFiscal />} />
              {/* TODO: `nip_buro` solo lo usa la maqueta de `CargaDocumentos`; quitarla al definir su flujo. */}
              <Route path="nip_buro" element={<NipBuro variant="pfae" />} />
              {/* NIP de Buró por persona (`NipBuroVariant`). Por ahora solo PFAE; `pf`, `pm` y `accionista` ya están
                  en `NipBuro` y se montan aquí cuando se migren (`consulta_buro_pf`, `consulta_buro_pm`). */}
              <Route path="consulta_buro_pfae" element={<NipBuro variant="pfae" />} />
              <Route path="conexion_cuentas" element={<ConexionCuentas />} />
              <Route path="confirmacion_accionista" element={<AccionistaConfirmacion />} />
              <Route path="expediente_pfae" element={<ExpedientePFAE />} />
              <Route path="validando_expediente_pfae" element={<ExpedienteCompletado />} />
            </Route>
          </Route>

          {/* Expediente y ofertas: requieren sesión. */}
          <Route element={<ProtectRouteAuthenticated />}>
            <Route path="" element={<TofuLayout size="lg" />}>
              {/* Pre-oferta por empresa (`ofertaPorEmpresa`); la comparativa del marketplace es `seleccionando_oferta`. */}
              <Route path="oferta" element={<OfertaPorEmpresa />} />
              <Route path="perfil_ingresos" element={<PerfilIngresosMercader />} />
              <Route path="check_list" element={<ListaRevision />} />
              <Route path="docs_dictamen" element={<ExpDictamen />} />
              <Route path="docs_empresa" element={<ExpEmpresa />} />

              <Route element={<ProtectRouteByFormStatus attribute="loan_application_information_status" />}>
                <Route path="expediente_informacion_solicitud" element={<ExpInformacionSolicitud />} />
              </Route>

              <Route element={<ProtectRouteByFormStatus attribute="references_status" />}>
                <Route path="expediente_referencias" element={<ExpReferencias />} />
              </Route>

              <Route element={<ProtectRouteByFormStatus attribute="bank_information_status" />}>
                <Route path="expediente_informacion_bancaria" element={<ExpInformacionBancaria />} />
              </Route>

              <Route path="expediente_personas" element={<ExpPersonas />} />
              <Route path="expediente_validacion_identidad" element={<ExpValId />} />
              <Route path="expediente_revision" element={<ExpReview />} />
            </Route>

            {/* Pantallas que el diseño resuelve a todo lo ancho, fuera de la columna de captura. */}
            <Route path="" element={<TofuLayoutWide />}>
              <Route path="seleccionando_oferta" element={<Ofertas />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default OnboardingRouter;
